import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Showcase from "@/components/Showcase";
import Gallery from "@/components/Gallery";
import Booking from "@/components/Booking";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div className="bg-[#180407]">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Showcase />
        <Gallery />
        <Booking />
      </main>
      <Footer />
    </div>
  );
}
